/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useQuery } from '@apollo/client';


export const useRegisterTdUser = (registerUser,tokenId,skip:boolean) => {

  const { loading, data, error, refetch } = useQuery(
    gql`
      query TDUserLoginRegisterUser($registerUser: RegisterUser!) {
        TDUserLoginRegisterUser(registerUser: $registerUser) {
        userId
    }
    }
    `,
    {
        variables:registerUser,
        skip: skip,
        context: {
        headers: {
          Authorization: 'Bearer ' + tokenId 
        },
      }
    }
  );
  if(error){
    sessionStorage.removeItem("hasCalled")
  }

    return {  loading, error, data, refetch};
};
